import React from "react";
import HeaderSpacer from "../components/HeaderSpacer";
import Breadcrumbs from "../components/Breadcrumbs";
import GalleryCard from "../components/GalleryCard";
import { Helmet } from "react-helmet-async";
import printsPic from "../images/shop/SoldOutPrints/sm/1_thredbo4.webp";
import paintingsPic from "../images/shop/Stockroom/pigeonsDogsNewYorkers/sm/6_pigeonsDogsNewYorkers.webp";

function Shop() {
  return (
    <div>
      <Helmet>
        <title>Tyrone Layne | Shop</title>
      </Helmet>
      <HeaderSpacer />
      <Breadcrumbs />

      <div className='galleryGrid'>
        <GalleryCard
          source={printsPic}
          description="Click to view Limited Edition Prints."
          linkTo='/prints'
          label='Limited Edition Prints'
        />
        <GalleryCard
          source={paintingsPic}
          description="Click to view Original Paintings."
          linkTo='/painting-shop'
          label='Original Paintings'
        />
      </div>
    </div>
  );
}

export default Shop;
